import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);
// 解决重复点击导航路由报错
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
export default new Router({
  routes: [
    {
      path: "/",
      component: () => import("../components/Main.vue"),
      redirect: "/home",
      children: [
        {
          path: "/home",
          component: () => import("../views/home/home.vue"),
          meta: {
            title: "网站首页",
          },
        },
        {
          path: "/culture",
          component: () => import("../views/culture/culture.vue"),
          meta: {
            title: "黄酒文化",
          },
        },
        {
          path: "/company",
          component: () => import("../views/company/company.vue"),
          meta: {
            title: "单位概况",
          },
        },
        {
          path: "/product",
          component: () => import("../views/product/product.vue"),
          meta: {
            title: "产品溯源",
          },
        },
        {
          path: "/companydetail",
          component: () => import("../views/home/home.vue"),
          meta: {
            title: "酒家详情",
          },
        },
        {
          path: "/news",
          component: () => import("../views/news/news.vue"),
          meta: {
            title: "新闻资讯",
          },
          children: [
            {
              path: "/more",
              component: () => import("../views/news/newschild.vue"),
              meta: {
                title: "更多新闻",
              },
            },
          ],
        },
        {
          path: "/news/detail",
          component: () => import("../views/news/newsdetail.vue"),
          meta: {
            title: "新闻详情",
          },
        },
        {
          path: "/info",
          component: () => import("../views/info/info.vue"),
          meta: {
            title: "信息公开",
          },
        },
        {
          path: "/notice",
          component: () => import("../views/news/notice.vue"),
          meta: {
            title: "通知公告",
          },
        },
        {
          path: "/productdetail",
          component: () => import("../views/product/productdetail.vue"),
          meta: {
            title: "产品详情",
          },
        },
        {
          path: "/service",
          component: () => import("../views/service/service.vue"),
          meta: {
            title: "服务互动",
          },
        },
        {
          path: "/group",
          component: () => import("../views/group/group.vue"),
          meta: {
            title: "黄酒协会",
          },
        },
        {
          path: "/unitoverview",
          component: () => import("../views/unitoverview/unitoverview.vue"),
          meta: {
            title: "单位概况",
          },
        },
        {
          path: "/business",
          component: () => import("../views/company/business.vue"),
          meta: {
            title: "酒企黄页",
          },
        },
        {
          path: "/mapmore",
          component: () => import("../views/home/mapMore.vue"),
          meta: {
            title: "产业地图",
          },
        },
        {
          path: "/goods",
          component: () => import("../views/company/goods.vue"),
          meta: {
            title: "精品推荐",
          },
        },
        {
          path: "/goodsdetail",
          component: () => import("../views/company/goodsdetail.vue"),
          meta: {
            title: "产品详情",
          },
        },
        {
          path: "/businessdetail",
          component: () => import("../views/company/businessdetail.vue"),
          meta: {
            title: "酒企详情",
          },
        },
        {
          path: "/video",
          component: () => import("../views/company/video.vue"),
          meta: {
            title: "黄酒宣传",
          },
        },
      ],
    },
  ],
});
